export const ADD_APPLICATION_NOTIFICATION = 'ADD_APPLICATION_NOTIFICATION';
export const REMOVE_APPLICATION_NOTIFICATION =
  'REMOVE_APPLICATION_NOTIFICATION';
